export const webMaps = [
  {
    name: 'Active Wildfires',
    map: '89ff30d783b849c8b22fc812d4c2f205',
    id: 0,
  },
  {
    name: 'Air Quality (blotch)',
    map: '92e772c4f65a4848a29bcc24c8f61bab',
    id: 1,
  },
  {
    name: 'Air Quality (sensors)',
    map: '730f553d21ea49e5a6cf38fe6cc63dc4',
    id: 2,
  },
  {
    name: 'Power Plants',
    map: 'f18b0ae4d06743bd87cbaea51e8109e9',
    id: 3,
  },
  {
    name: 'Alternative Fuel Stations',
    map: '511dfe0a721c40f598cb2195c2a02527',
    id: 4,
  },
];
